import { AccountDataType } from 'modules/utils/types';
import { getAccountDataObject } from 'modules/utils/utils';

export const patchAccountData = (
  data: any,
  setAccountDataContext: React.Dispatch<React.SetStateAction<AccountDataType>>,
) => {
  setAccountDataContext(getAccountDataObject(data));
};
